import { string } from 'prop-types';
import React from 'react';

import SvgIcon from 'ravenjs/lib/SvgIcon';

import { DEFAULT_COLORS } from 'constants/colors';

const AlertTriangleIcon = ({ height, viewBox, width, color, ...rest }) => {
    return (
        <SvgIcon width={width} height={height} viewBox={viewBox} {...rest}>
            <path
                d="M0.75 15.75L9 1.5L17.25 15.75H0.75ZM3.3375 14.25H14.6625L9 4.5L3.3375 14.25ZM9 13.5C9.2125 13.5 9.39062 13.4281 9.53438 13.2844C9.67813 13.1406 9.75 12.9625 9.75 12.75C9.75 12.5375 9.67813 12.3594 9.53438 12.2156C9.39062 12.0719 9.2125 12 9 12C8.7875 12 8.60938 12.0719 8.46563 12.2156C8.32188 12.3594 8.25 12.5375 8.25 12.75C8.25 12.9625 8.32188 13.1406 8.46563 13.2844C8.60938 13.4281 8.7875 13.5 9 13.5ZM8.25 11.25H9.75V7.5H8.25V11.25Z"
                fill={color}
            />
        </SvgIcon>
    );
};

AlertTriangleIcon.propTypes = {
    height: string,
    viewBox: string,
    width: string,
    color: string,
};

AlertTriangleIcon.defaultProps = {
    height: '18',
    viewBox: '0 0 18 18',
    width: '18',
    color: `${DEFAULT_COLORS.ORANGE}`,
};

export default AlertTriangleIcon;
